import type { HandlerFn, HandlerContext } from "..";
import type { ExecutorCommand } from "../../../../Executor";

/** Extract raw value from a serialized field (handles {html, text} objects). */
function rawValue(v: any): string | number | null {
  if (v == null) return null;
  if (typeof v === "object" && "text" in v) return v.text;
  if (typeof v === "object" && "str" in v) return v.str;
  return v;
}

/** Resolve target PKs from handler context using pk_value, pk_field, or selectedPks. */
export function resolvePks(ctx: HandlerContext): (string | number)[] {
  if (ctx.config?.pk_value != null) return [ctx.config.pk_value];
  const pkField = ctx.config?.pk_field;
  if (pkField && ctx.selectedRows.length > 0) {
    return ctx.selectedRows.map((r) => rawValue(r[pkField])).filter(Boolean) as (string | number)[];
  }
  return ctx.selectedRows.map((r) => r.pk);
}

export const executorHandler: HandlerFn = (ctx) => {
  const executor: ((cmd: ExecutorCommand) => void) | undefined =
    (window as any).executor;
  if (!executor) return;

  const pkParam = ctx.config?.pk_param ?? "host_pk";

  executor({
    params: {
      kind: ctx.config?.executor_kind,
      [pkParam]: resolvePks(ctx),
      ...ctx.optionValues,
    },
    modal: ctx.config?.modal_title,
  });
};
